import cn from "classnames";
import { COLORS_OPTIONS } from "constants/options";
import { useTranslation } from "react-i18next";

import { ProductColorLabelProps } from "./ProductColorLabel.types";

import styles from "./ProductColorLabel.module.scss";

const ProductColorLabel = ({ colorValue }: ProductColorLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.colorLabel}>
      <div
        className={cn(styles.colorLabel_colorIcon)}
        style={{
          background: COLORS_OPTIONS.find(
            (option) => option.value === colorValue
          )?.color
        }}
      />
      {t(colorValue)}
    </div>
  );
};

export default ProductColorLabel;
